import axios from "axios";
import CookieKeys from "../model/constants/cookieKeys";
import router from "../router";
import mainStore from "../store/store";

function setLoader(val){
  mainStore.dispatch("setLoader",val);
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  timeout: 100000 // request timeout
});
// request interceptor
service.interceptors.request.use(
  config => {
    let token = localStorage.getItem(CookieKeys.AUTH_KEY);
    config.headers["authorization"] = `Bearer ${token}`;
    setLoader(true);
    return config;
  },
  error => {
    setLoader(false);
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    setLoader(false);
    return response
  },
  error => {
    setLoader(false);
    if (!error.response)
    {
      return Promise.reject(new Error("Service Unavailable"))
    }
    if (401 === error.response.status) {
      const url = (error.config && error.config.url) || ''
      if (!url.includes('SelfService/session-events')) {
        router.push('/pages/login').catch(() => {})
      }
    }

    return Promise.reject(error);
  }
);

export default service;
